module.exports = __webpack_public_path__ + "media/images/emblems/Chevilly-coat_of_arms-0fa47782f484cac44af6d8afba37dc12.svg";